import { Box, ColorOptions, IconButton, Loader, Spacer, TextInputNewProps } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../../../data/store'
import { TextInputWithInfo } from '../TextInputWithInfo'

export const Pincode = (props) => {
  const { fetchPincodeData } = useStores((store) => ({
    fetchPincodeData: store.fetchPincodeData,
  }))
  const [verifyStatus, setVerifyStatus] = useState(
    !props.allValues?.[props.cityField] && !props.allValues?.[props.stateField] ? '0' : '1',
  )
  useEffect(() => {
    if (
      !props.editable &&
      !props.allValues?.[props.cityField] &&
      !props.allValues?.[props.stateField] &&
      props.value?.length === 6
    ) {
      setVerifyStatus('3')
      fetchPincodeData(props.value)
    }
  }, [props.value, props.editable])
  const [fetchPincodeDataApi, fetchPincodeDataHandler] = useLazyApiData(fetchPincodeData)
  useEffect(() => {
    if (fetchPincodeDataHandler?.state === 'fulfilled') {
      if (fetchPincodeDataHandler?.data) {
        setVerifyStatus('1')
        const data = fetchPincodeDataHandler?.data?.data[0]
        props?.setFieldValue(props.cityField, data?.cityName)
        props?.setFieldValue(props.stateField, data?.stateName)
      }
    } else if (fetchPincodeDataHandler?.state === 'rejected') {
      setVerifyStatus('2')
    }
  }, [fetchPincodeDataHandler?.state])

  const onChange = (text) => {
    setVerifyStatus('0')
    props?.setFieldValue(props.cityField, undefined)
    props?.setFieldValue(props.stateField, undefined)
    props.onChange(text)
  }
  const pinCodeError = props.error
    ? props.error
    : verifyStatus === '0'
      ? 'Please Search Pincode'
      : verifyStatus === '2'
        ? 'Wrong pincode'
        : ''
  return (
    <Box flexDirection="row" align="flex-end">
      <TextInputWithInfo {...props} error={pinCodeError} onChange={onChange} />
      <Spacer direction="horizontal" size={18} />
      {fetchPincodeDataHandler.state === 'pending' && (
        <Box justify="flex-end" paddingBottom={4}>
          <Loader type={'small'} />
        </Box>
      )}
      {fetchPincodeDataHandler.state !== 'pending' && props.editable && (
        <IconButton
          id="SEARCH"
          color="PRIMARY"
          disabled={props?.value?.length !== 6}
          onPress={() => {
            if (props.value?.length > 0) {
              setVerifyStatus('3')
              fetchPincodeDataApi(props.value)
            }
          }}
        />
      )}
    </Box>
  )
}

const styles = {
  textinputStyle: (editable: boolean) =>
    ({
      borderColor: editable ? ('#D1D3E2' as ColorOptions) : undefined,
      labelPaddingBottom: 3,
      borderRadius: 4,
      labelFontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      fontWeight: '500',
      selectionColor: 'BLUE',
      editable,
      paddingHorizontal: editable ? 8 : 0,
      color: 'BLACK_21',
      paddingVertical: 8,
      placeholderTextColor: '#757575' as ColorOptions,
      bgColor: editable ? 'WHITE' : 'TRANSPARENT',
      disabled: !editable,
    }) as TextInputNewProps,
}
